import React from 'react'
import { useService } from '@pushly/aqe/lib/hooks'
import { DomainDto } from '../../dtos/domain'
import { AppService } from '../../services/index'
import { AppState } from '../../stores/app'
import { AbilityAction } from '../../enums/ability-action.enum'
import { asCaslSubject } from '../../stores/app-ability'
import { SubjectEntity } from '../../enums/ability-entity.enum'
import { FeedsDataView } from '@pushly/aqe/lib/components/feeds/feeds-data-view'
import { Domain } from '@pushly/models/lib/structs/domain'

export const FeedsDataViewWrapper = (props: { domain: DomainDto; appState: AppState }) => {
    const appSvc = useService(AppService)

    const { appState } = props

    const canMutate = (): boolean => {
        return appState.abilityStore.can(
            AbilityAction.UPDATE,
            asCaslSubject(SubjectEntity.FEED, { domainId: props.domain.id }),
        )
    }

    return (
        <FeedsDataView
            hideRefresh={true}
            hideAutoRefreshOptions={true}
            domain={Domain.parseJsonObject(props.domain)}
            appSvc={appSvc}
            canMutate={canMutate}
            feedsPath={`/domains/${props.domain.id}/notifications/feeds`}
        />
    )
}
